import React, { useState, useEffect } from "react";
import { CheckCircle, ArrowForward } from '@mui/icons-material';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const PricingSection = () => {
  const [isYearly, setIsYearly] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Simple check on mount and on resize
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // example breakpoint for mobile
    };

    handleResize(); // check on mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const pricingData = {
    monthly: [
      {
        popular: "2 Months Free",
        title: "Starter",
        price: "$99/",
        pricesubdesc: "month",
        features: "Up to 3 Users | Additional Users: $25/mo",
        desc: "For individual contractors or small teams getting started.",
        keyfeatures: [
          "Everything in starter + Advanced Scheduling & route Optimization.",
          "Job Costing & workflow automations.",
          "QuickBooks & accounting integrations.",
          "Automated SMS/email job updates.",
          "Priority email + chat support.",
          "Enhanced reporting & job analytics."
        ],
        lstone: "Ideal For:",
        lastdesc: "Solo Contractors, small repair teams or weekend operators."
      },
      {
        popular: "2 Months Free",
        title: "Growth",
        price: "$249/",
        pricesubdesc: "month",
        features: "Up to 10 Users | Additional Users: $25/mo",
        keyfeatures: [
          "Evrything in starter + Advanced Scheduling & route Optimization.",
          "Job Costing & workflow automations.",
          "QuickBooks & accounting integrations.",
          "Automated SMS/email job updates.",
          "Priority email + chat support.",
          "Enhanced reporting & job analytics."
        ],
        lstone: "Ideal For:",
        lastdesc: "Small to mid-size teams scaling operations across multiple jobs daily."
      },
      {
        popular: "2 Months Free",
        title: "Enterprise",
        price: "Custom/",
        pricesubdesc: "month",
        features: "Tailored to your team size & usage",
        keyfeatures: [
          "All growth plan features + white glove onboarding.",
          "Custom integrations & advanced security/compliance.",
          "Dedicated account manager.",
          "24/7 premium support & custom SLAs."
        ],
        lstone: "Ideal For:",
        lastdesc: "Franchises, regional service companies, or organizatins with custom workflows."
      },
      {
        popular: "2 Months Free",
        title: "Tailored to your team size & usage",
        price: "Every Plan Includes",
        features: "For individual contractors or small teams getting started.",
        keyfeatures: [
          "HVAC scheduling & dispatch tools",
          "Invoicing & CRM features",
          "Mobile app for techs",
          "Real-time reporting"
        ],
        lstone: "Ideal For:",
        lastdesc: "Professional contractors, multi-crew companies, or ops-heavy firms."
      }
    ],
    yearly: [
     {
        popular: "2 Months Free",
        title: "Starter",
        price: "$99/",
        pricesubdesc: "month",
        features: "Up to 3 Users | Additional Users: $25/mo",
        desc: "For individual contractors or small teams getting started.",
        keyfeatures: [
          "Everything in starter + Advanced Scheduling & route Optimization.",
          "Job Costing & workflow automations.",
          "QuickBooks & accounting integrations.",
          "Automated SMS/email job updates.",
          "Priority email + chat support.",
          "Enhanced reporting & job analytics."
        ],
        lstone: "Ideal For:",
        lastdesc: "Solo Contractors, small repair teams or weekend operators."
      },
      {
        popular: "2 Months Free",
        title: "Growth",
        price: "$249/",
        pricesubdesc: "month",
        features: "Up to 10 Users | Additional Users: $25/mo",
        keyfeatures: [
          "Evrything in starter + Advanced Scheduling & route Optimization.",
          "Job Costing & workflow automations.",
          "QuickBooks & accounting integrations.",
          "Automated SMS/email job updates.",
          "Priority email + chat support.",
          "Enhanced reporting & job analytics."
        ],
        lstone: "Ideal For:",
        lastdesc: "Small to mid-size teams scaling operations across multiple jobs daily."
      },
      {
        popular: "2 Months Free",
        title: "Enterprise",
        price: "Custom/",
        pricesubdesc: "month",
        features: "Tailored to your team size & usage",
        keyfeatures: [
          "All growth plan features + white glove onboarding.",
          "Custom integrations & advanced security/compliance.",
          "Dedicated account manager.",
          "24/7 premium support & custom SLAs."
        ],
        lstone: "Ideal For:",
        lastdesc: "Franchises, regional service companies, or organizatins with custom workflows."
      },
      {
        popular: "2 Months Free",
        title: "Tailored to your team size & usage",
        price: "Every Plan Includes",
        features: "For individual contractors or small teams getting started.",
        keyfeatures: [
          "HVAC scheduling & dispatch tools",
          "Invoicing & CRM features",
          "Mobile app for techs",
          "Real-time reporting"
        ],
        lstone: "Ideal For:",
        lastdesc: "Professional contractors, multi-crew companies, or ops-heavy firms."
      }
    ]
  };

  const activePlans = isYearly ? pricingData.yearly : pricingData.monthly;

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true
  };

  return (
    <>
      <div className="pricing-container">
        <h2>
          Affordable HVAC Software Plans for <br />
          <span>Contractors, Teams & Fleets</span>
        </h2>
        <p>
          Choose a plan that fits your HVAC business and get powerful features
          without the hefty price tag.
        </p>

        <div className="plan-tab">
          <div className="tab">
            <div
              className={!isYearly ? "tab-btn active" : "tab-btn"}
              onClick={() => setIsYearly(false)}
            >
              Monthly
            </div>
            <div
              className={isYearly ? "tab-btn active" : "tab-btn"}
              onClick={() => setIsYearly(true)}
            >
              Yearly
            </div>
          </div>
        </div>

        {isMobile ? (
          <Slider {...sliderSettings}>
            {activePlans.map((plan, index) => (
              <div
                key={index}
                className={`plan-card ${plan.popular ? "popular-plan" : ""}`}
              >
                {plan.popular && <p className="popuplar">{plan.popular}</p>}
                <h3>{plan.title}</h3>
                <p>
                  <strong>{plan.price}</strong>
                  {plan.pricesubdesc}
                </p>
                <span>{plan.features}</span>
                <hr />
                <p> Key Features:</p>
                {plan.keyfeatures && plan.keyfeatures.length > 0 && (
                  <ul>
                    {plan.keyfeatures.map((feature, i) => (
                      <li key={i}>
                        <div className="icon-bx">
                          <CheckCircle
                            style={{
                              marginRight: "8px",
                              verticalAlign: "middle",
                              color: "#4F46E5"
                            }}
                          />
                        </div>
                        <div className="txt-icnbx">{feature}</div>
                      </li>
                    ))}
                  </ul>
                )}
                <p>{plan.lstone}</p>
                <p>{plan.lastdesc}</p>
                <button className="btn">
                  Get Started{" "}
                  <ArrowForward
                    style={{ marginLeft: "8px", verticalAlign: "middle" }}
                  />
                </button>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="plans-wrapper">
            {activePlans.map((plan, index) => (
              <div
                className={`plan-card ${plan.popular ? "popular-plan" : ""}`}
                key={index}
              >
                {plan.popular && <p className="popuplar">{plan.popular}</p>}
                <h3>{plan.title}</h3>
                <p>
                  <strong>{plan.price}</strong>
                  {plan.pricesubdesc}
                </p>
                <span>{plan.features}</span>
                <hr />
                <p> Key Features:</p>
                {plan.keyfeatures && plan.keyfeatures.length > 0 && (
                  <ul>
                    {plan.keyfeatures.map((feature, i) => (
                      <li key={i}>
                        <div className="icon-bx">
                          <CheckCircle
                            style={{
                              marginRight: "8px",
                              verticalAlign: "middle",
                              color: "#4F46E5"
                            }}
                          />
                        </div>
                        <div className="txt-icnbx">{feature}</div>
                      </li>
                    ))}
                  </ul>
                )}
                <p>{plan.lstone}</p>
                <p>{plan.lastdesc}</p>
                <button className="btn">
                  Get Started{" "}
                  <ArrowForward
                    style={{ marginLeft: "8px", verticalAlign: "middle" }}
                  />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default PricingSection;
